import React from 'react';

import { PageSection } from 'components';
import { useTranslation } from 'react-i18next';
import {
    AccordionDescription,
    AccordionTitle,
    MoreLink,
    MoreLinkContainer,
} from './styled';
import { Accordion, IAccordionStylesProps, Icon } from 'kl-b2c-ui-kit';
import { Title, HeaderContainer, SubmitButton } from '../../styled';

const sectionConfig = {
    CWrap: {
        css: {
            background:
                'radial-gradient(338.16% 159.51% at -3% 6%,rgba(89, 237, 153, 1),rgba(103, 171, 236, 1),rgba(142, 138, 251, 1))',
            marginTop: -100,
            paddingTop: 100,
            marginBottom: 100,
            paddingBottom: 100,

            '@media(max-width: 1279px)': {
                marginTop: -120,
                paddingTop: 60,
            },

            '@media(max-width: 767px)': {
                marginTop: -130,
                paddingTop: 80,
            },
        },
    },
    ContentArea: {
        css: {
            paddingTop: 100,
            paddingBottom: 90,
            display: 'block',
            zIndex: 5,
            position: 'relative',

            '@media(max-width: 1023px)': {
                paddingBottom: 100,
            },
        },
    },
};

const accordionStyles: IAccordionStylesProps = {
    ItemConfig: {
        css: {
            padding: '35px 30px',
            background: 'rgba(225, 225, 225, .15)',
            borderRadius: 16,
            marginBottom: 16,

            '@media(max-width: 1023px)': {
                padding: '24px',
            },
        },
    },
    HeaderConfig: {
        css: {
            padding: '0px 0px',
            alignItems: 'center',
        },
    },
    BorderConfig: {
        css: {
            paddingTop: 12,
        },
    },
    BodyConfig: {
        css: {
            padding: '0px 0px 0px 0px',
        },
    },
    ActiveHeaderConfig: {
        css: {
            p: {
                color: '#1d1d1b',
            },
        },
    },
    ActiveItemConfig: {
        css: {
            backgroundColor: 'rgba(255,255,255, 0.4)',
            background:
                'linear-gradient(to right, rgba(124, 153, 251, 0.1) 60%, rgba(157, 135, 249, 0.3))',
        },
    },
};

export const Cooperation = () => {
    const { t } = useTranslation('pages/academy-alliance');

    return (
        <PageSection config={sectionConfig}>
            <HeaderContainer>
                <Title>{t('cooperation-title')}</Title>
                <SubmitButton
                    onClick={() =>
                        (window.location.href =
                            'mailto:academy.alliance@kaspersky.com')
                    }
                    color={'primary-contrast'}>
                    {t('request')}
                </SubmitButton>
            </HeaderContainer>

            <Accordion
                distanceBetweenItems={0}
                items={[
                    {
                        key: 'basic',
                        title: <AccordionTitle>{t('basic')}</AccordionTitle>,
                        body: (
                            <>
                                <AccordionDescription>
                                    {t('basic-description-1')}
                                </AccordionDescription>
                                <br />
                                <AccordionDescription>
                                    {t('basic-description-2')}
                                </AccordionDescription>
                                <MoreLinkContainer>
                                    <MoreLink
                                        onClick={() =>
                                            window.open(
                                                process.env.REACT_APP_LOCALE ===
                                                    'ru'
                                                    ? '/assets/files/associate_ru.pdf'
                                                    : '/assets/files/associate_en.pdf',
                                                '_blank'
                                            )
                                        }>
                                        {t('more')}
                                    </MoreLink>
                                    <Icon
                                        name={'ArrowPaginationRight'}
                                        size={27}
                                        color={'black'}
                                    />
                                </MoreLinkContainer>
                            </>
                        ),
                    },
                    {
                        key: 'advantage',
                        title: (
                            <AccordionTitle>{t('advantage')}</AccordionTitle>
                        ),
                        body: (
                            <>
                                <AccordionDescription>
                                    {t('advantage-description-1')}
                                </AccordionDescription>
                                <br />
                                <AccordionDescription>
                                    {t('advantage-description-2')}
                                </AccordionDescription>
                                <MoreLinkContainer>
                                    <MoreLink
                                        onClick={() =>
                                            window.open(
                                                process.env.REACT_APP_LOCALE ===
                                                    'ru'
                                                    ? '/assets/files/advanced_ru.pdf'
                                                    : '/assets/files/advanced_en.pdf',
                                                '_blank'
                                            )
                                        }>
                                        {t('more')}
                                    </MoreLink>
                                    <Icon
                                        name={'ArrowPaginationRight'}
                                        size={27}
                                        color={'black'}
                                    />
                                </MoreLinkContainer>
                            </>
                        ),
                    },
                ]}
                config={accordionStyles}
                duration={0.5}
                iconOpen={
                    <Icon name={'ShowMore'} height={22} color={'white'} />
                }
                iconClose={
                    <Icon name={'ShowLess'} height={22} color={'white'} />
                }
            />
        </PageSection>
    );
};
